import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgPerkIncluded = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M17.0094 8.5957L10.1216 15.4836L6.99072 12.3527", stroke: "#21AA6B", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
const ForwardRef = forwardRef(SvgPerkIncluded);
export default ForwardRef;
